export const NEW_VEHICLE = {
  id: 'Q0FOOTMyMDU5MDkwNQ=',
  interiorColor: 'Black, Black, Santos Brown-Steel Grey, Black',
  exteriorColor: 'Brilliant Black',
  modelID: 'a3limo',
  modelYear: '2022',
  modelCode: '8YSBUY',
  modelName: '2022 Audi A3 Sedan',
  modelPrice: '$43,406.50',
  modelPriceRetail: '$43,406.50',
  modelPowerkW: '150 kW',
  modelMileage: null,
  audiCode: 'ATW77ZBH',
  stockNumber: '90905',
  trimName: '40 TFSI quattro Komfort 204 HP S tronic',
  kvpsSyncId: '93205',
  dealerName: 'Audi Queensway',
  dealerRegion: 'ON',
  vehicleType: 'new',
  warrantyType: null,
  modelImageFromScs:
    'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAAAI2Y9z_Vb_jH7yMqbrKSmURm9sjOKiN7HiIrZJN5ZM8--CBZ2XsklJEte6uEbJmVEJFR1PG9P9_H9w_4vn-4H-dc5_14P-5zX6_r-bqud8V3QOTtAWhNNRytfKz4Hdz49W09HKycHR5ZWTvbSleNElfoT31XIwAA5w4AwKB7CUwVK37S_jp73mDp_8KUpYDIy9vD2g2DbtEhIHFwsXpgK-DobvuAHENiJcJni_Pi83AXPYd-7YMDyxzV_AFnTgmC_LQtn3r9oe0PqgVwO4t31SHCvqFHIc2qhtHDYmhA4AeAqi8ChRUNsq74p9nJVblxSNyJqf0L4JoVUwPbAe5aOt9xCT8doRV1d4wCgLrGus_czp7XyTs_2nLxWcfPoh-zhwCWsoiTdFdhQrm8_jo5z3EJ2vr9qgNQyN-5GFe5EN_yqN2P4ihJsnw8JBJAsfF8Wv9vIydp-bWkCmuyIh1n6_oBbPM3zDQ4S7Psdn_Gc-Cs89FPU-I2tN9BEfNS6uMHTPxM68SF_Lm-ygG3ATxse37v70fT-8FnjlMrDAmwKQmmwwDyE8cFdHZf1vZaVAzVJUyYMGclLwSwMDxRZUF_R8mHCMdH7k17tYlimQPArv7fbs4-SlAB-_cOkCBv_XJNwhvAqVCVRbtPtpa98soS0dHxKWK2v1wBrP1GSZA1q6qeS5m9uEm0-B5msgMAvdQGTTkxtE8uK_xlfWdSHsKyT7wFIM-s_8R1b77wxLL3rXiHpa9RWUzjAE5KOHfJYOowzKPac5RKfDKranbnARy2kyDkSNXE_6JY_hx7Hzdv2XGIQ_uVFjaJd43XrF-sEwu88E0jPM8JCyBY3hvUUk56TBrjmuGY87TKSu1MJ4DrVHWf3tZbPMhV1qcIv_mhOiqM4DfKEH3fLVaBDMMJZmWxL28SknEcQ9UAphqqmbwdtbucJ5lzMHlHKOI1TU4sgJeOnPUd-CTLe2-OGDjVHce8UrmbA2Cd7HQ2zqXgMhuRUVb14Y3cIG9vMwBXzsUAox9CqrENn4-v39hWirX8dw7Az2ttSbTX9XSVD8hZjUbwNH44qWcALs7LV8bw-XWmD3OJOO07TEyEcRABeP9zZUHmtIb2wSnF2rjhP5tsmNMTAA98bD1f2p4YH3geyPNyHijeDCYqAFDle4p6m2CYfE7biHOKNP7LteusSL9ebfEv4gWJK9zmKHa4akclCR68kwHwT0iDsk7A9aQ7MdPm9QuL2PfDF9F-qY82DbefnNP9oN_9b4QCkUSzqgobgORZkUyvQsl1Qkw1ghhmTkg6BNLtANRZcHGJMhOLd820bqqW2SUbHKRuB7CnTK3p3JUOitvfC0VpH4lonw17h_RrU2lSFZS-mhTIH7zOQSSeI0Ki9R7Ax8N5DtVSyqbqE4wWHXfLhmacZEiRotgZaKeui-7JfZfb6c2--NX-3e1mAHc76QZe8XsLRnzx8w1LI3VpclR7CCDZBy8K5YSDXCls6kniWca6UkITdgBNLjYYL1iFiysH2GZThmWPLo6WawL4sC3FynM1O3TUvmqvzY_QEOupgp6ro0WglSrc8CvVxOimsZLo25iopisAfmqcpRCfVE-Tmr9HvHnCshgRaoTU911F3juM_5T68EuFY20M3ZFioEoxgAojd-pt1H31UvSv-VGRZ1768ptLCamEkp7x98TLd9XYRoy4Kfz56h7lIKqLk2a7TKJLTQ0tWyOFesxGcbT2YQDe3LO18q67NKUetFg6Gulb1DJu3AogM69KD53zStfPtyU9cVk67tsC120BLDur-K6iKlyTxj1JVtGNIuBXfTDSepFiwIU0nArJOgtm1zJIZauwSMEGwFu73Mev8U_Ydo4chWrkz1syY89XAaip9f1lI6GcpkZZbLI5ce3dD2IXGwE0y467y-V1OvgDL6W1yS11R6XyGD33yJ3Lmn2jIVg5-V3wPExOIHAz8wdwerc1behV1hdTvKxdUhp1ztxO2CSA7YyFU9gBd5rmxbid7X-DG3rZN0wA1BCduOfzxeKondEw9LZcwOdhTA06ya3seK5sy3s56uPRpxw5udtb0_4SALoL1RMEb0c9patpqZa_e2Dfg9dcAdDB7LiWW6aPdiWm7QoB87O3ClUBSJOq6tjqeG3ffuIvGctHf8slZr2-lALoV_GJRIFqZf0c5kJ4_Qafbv-fqkVEjY92YoQJSd-tKd6ZsifzRC-Kk4kDKJN4tWS10KS-zP9nzOLd150cqiddADpR51tsF-iSiFHEijerjrcPXVxHtbkaxWMQluT-4FsGl8CsWcM_AywT5QDabRZOKXQlzSUPhY9FBbu-ihoRlARwyTfjCX2VwZm3ua20meOyEvI89ihvpKbbylF6ZE2Mdi_uSuXJnjYk66BoEUd6iX1zQLfG7f2eyUOHHtnGx4jr5EYMuCkHvmSlPRmlKyTMWBXrxAwAu8POeTzhneY4xM-TX1Mpqv9zMN2LuNPNvrr_vFDv_K0QugfYQP5CL0ERAK1KI6PHDW_BTxv_5gMRZdU6IsEYABnYjflfOhI7z1Bq9Wisao7HjH-6CCBNrqnKn8annVHe7d5utfsTpfWRKQDuWFi9j_gnypPh2UcerBujQL-9vQCAXEVODkz21XIbmfrWVWHhEWMjw4jgkDOr92Y4vz5H_Q_vF32VmcM3CgYAfOXxlmOb2y2jR0vz6-rjwpB5XVVDxKjkISEXY4k34emqwfj5XiO1kBOUIZmWr2ms85yrhP51FMW0-KtsEc_R6bgu7Vaazq5JPTKPTB9LUpZnj5KNA1DexTWg8A3mxW-1A_sNs-LA9JqyUQA9vhXFkfutGfnqqICZO6KzNHs53QD6S3j9lciP03s4ZsMQkxxbfy5TRxRADi_uvoLVke-UfvkHrpdNAxgCuBDPHi7KCz1vcejo5WE0ohAeXbK3HhMCEBPVyf05JHodq37P028lIsEphAk5Q7qPyakexcq32nm4KXJe3Xdh8qUjqk1-SqEZ57Vvxp4hnvadEwGXHoreAZDbhsRMYiuQ4LXzgNPpXzZHi4HbXwB0M386UjkwmHb95HFGlf_9d4lPqmUBbIXYJsNiyQZSLr-Qup2Zsk9cS9kAFmtnP3lTF6ZZi5-8uBG4_u9Zn7xElKGh0Lsl_g3VRb5yArNH161wP_6hQI7D_ucfsqXmF5bDmHl6OQEa8KGNHBFmoXSEATIep8pl4pb6fYh5iFRvoiihOtX7VOFpxjfWBF2zRtr70waoum1z9RlIL689V87T3PbUHk25Z0qLXCRcsPNqrLWmKusSj94nR3xMCj4mCp3DXb2SUaai5rHaAb2Ekdm99LFEKQBZeSfq3M0cHRuDb7JOzu6oOxtZeABoP741WiH6OoNeyvEisaJ5xDpR1wZSX4vQB8UkRZ2OLQUz4hknTnxfKarCzcyWdJfYrILBN8ILmbud8r9jpQUB_CVLRefzupaqqPkYe_03WWFhW8IagKf6VEusXXS_UgPNGs2DzQ1ntGOQ1vOy7ygWBhNKyJQZ3Ws9bXi9nETKBWD93GShvuBEWWTDIEvJD6qrjsfMyEXW5mTDueyoe5_vN0_ZtL4jFSXsQ52CLWchr0mroTdx4yKNODbrqlZCJAmAkZc_8yrkp6X8yiNosvvsRVe3ELYPIMv7pwV6HccsExlXab75fKJV46RKA3Beel4nNchlyfpo54RqvYhGjBWPPLZeWs_JAabjdZMenVGLypqp4MSgaJCLSthcq2PoPvacIUHb6u6NcH8C1IFEvv9oaHZqOjdwA5evl2A5ffgKKXVAQCV6bUi0a-T5n9X47J1GlvYCVJvVKet-KXvTJdXPdh4VylcK4srkFgBMLnhPMuZJXy-9Wh6JNZcnUyERRb1cZGSH2Q3LoElFlepwk1V_velX4X3IA2S9K8OZkz-uG6rsmtTnX9HbnDIGsP8G68P7_SoeFKbOqcCyKyVoZxFRo2Z5m4xvfdLd9c1J5lePFYO4BQw6h_K4ryM_P-onZ2aQ9F0m1sIZhjeh_iwoP7CgmEpHmjmEfJZhKO5Z-vj3aygKa6Wvsc3e4FqlzZutz3smPEqPXCSLPN5VkteyIjKW2ZFc4eFpW_95DIAfR1zFt5zaW_s5y-TdW8r5LOa2UL_To0DxgKmYmLsYj-MhfWhBrmu1gvyihe_IVoJcd366m6clccETz_O6GHGHl0bZcFA3PUOAmu_MRbWVfThBzIQyX4bjFnf3iBp7TPM7rFV5uC6deQL5m5eVq43jZUfWah-q9fFuHvILbrQAvuues1tnqF6yLTjLZVDM7afY-bgCQN-SMezvVZwnE2dSoXfzIZ21jyTqJ8NH7DN7AyokA7Ta_WlV0yNqsgwQERfiXtCaVgQnD9QtJmg9-jbD63L-DYDeWtI5Z0Q0sU24PcU0DzsRIQpDPVTdCkETYoTKtiSOgzUiiwv8a-9sfQA0vPqk6-lOaD2Vhv3baMyPDf5CWeTSNmqlb9nlhqmTX3rERL4weFxwX3Aa5cJIgIFolWVkiEtRb2PU3Pfw2oQ6ImKa8etZzGDqxTGpqB_dlvKU0e7bAI7pe0zVkN77DCZy5T2E-HYTf3dxItLqC9JRP7q1HrPWIzDY8PSDBXUKYolGNBNfYYljG4eGF-_2tWhD42U5XdTT8rXrkJ2EDSyrlTu7ejlvvApbRizp15YCvmp0ugS412IyWeEP6YfYkNaVx_TTTEVjeJdjN3_tugoo1hfVoa6Y2PIfysw-NzadI9Jh2YAqPJfCnRrkb--9XQNNZ_tnwjpkwvVMHB-9FUGZZ13jgraTNeJ-Dz-TGnKLUYezRaK8dfYRWza5MMqXiuH-yLTdyxCRlkTReiHT7x0NT89vSI7SxqW3nasx5kXccbyPjfAYOvYsCpp61s7j2fjy2IAFQIK5hzZNFZLYS11HvYGXXtuZEPdIA8inXkJTwszhzC6Z1-lF12WyG6qGaC9SsaZQ_ECPX_XrcWnU6UBa8nppJYC9NEu3D6vYDJ2eH_anzO4K3YyYQOQSEcOqW1gE6zgppg-JN-ttGqteRP2Zm9CnnfD8S_ErV35kt8w-owqN98Mjj11zJoIBG3JnyuW-HURlS-Q-kBIGkFP9VnZY0NrQY6VfC7WxGmMNF061AbydZxNUKFuh_KOPLOsMwxYlE4X9DoBXhGOaU65wyNPu7N7-tiMgvNry6Reip-gwy8m9FozBxucBa0Lr6PoziagbTOWLiyYLkVfYokv60Rx1iBfQ20O58JjMc5MlzHHWSH7DEE63-ts39bQEwHOHF1rpR3FSb0fSk6PxcdzC8cHOACrSJQSWL8iHdOVI09-TVn7VFC-ESOvz88I4_e1bx-x3Pcpvzoeo4iIlTwE8LppidFDaCc10Yfi3BU-5T-F3DvUP1ysNgpxvcMUUMyUrvtSyOr71PMsczbH9UreXz9noPYlwaC4YW92oDeqWQzPDSgb__Qj5vKuT5p3X-5--CGvOzUc-9FaP_zXbXL9uUfG0VAEpZj-RGanvbKm9ysLcXstM0-eDYIvEhZecNsh5SZiVIkiN3K8duwu4O29ebpnfdEHU6AvlVOzZe370humvZth6raxtRcVllPkG_elio9yT0cYE8c58Rj8aITt6NAfgzQd8bMp6v7eNCxpE0ak9OO5AXph39nH2IhbQt6tVOgT3eUvvGfIjTppcoZv4OWmkYB73kE8_0uLFJTLxW6i6TXWMRqttvSrJt1ge_dHNpTHVRf-i-6VcXRNDlt_-fs596RgKpZX3hIjru7vfqCWWNoNWGiWOtFWpVPvdopG_7bpxUNI_Z8Rwd2o2kVoVSWPTvdDkQ-Yr3E7nUS3upiR7QHQ_uC1BYPYxmv2Lpk4EfNfoXC2kcxo_1vwe7WBHE-ulyedC0aMsboJLXk99WUbSFT9ZPAZEGADOmKOFkBotpKtoOe_2v5_Af29QuP9bJNCCEQZn0GqOvvaA_64LF7w9nN2tPKxc-O97uLm7UnIJ_j8vakIFIzWD_wFoBxQm7hEAAA.png',
  isAvailableNow: true,
  vin: 'WAUGUCGY4NA033730',
  bodyType: null,
  saleOrderType: null,
  vehicleInventoryType: 'available-now',
  vehicleOrderStatus: null,
  driveType: 'All-wheel drive',
  gearType: 'Automatic',
  distanceFromUser: 14,
  galleryImages: [],
};

export const USED_VEHICLE = {
  id: 'Q0FOOTMxNjhQNTIyOA=',
  interiorColor: null,
  exteriorColor: 'Terra Gray Metallic',
  modelID: 'a8l',
  modelYear: '2021',
  modelCode: '4N85DA',
  modelName: '2021 Audi A8 L',
  modelPrice: '$109,994.00',
  modelPriceRetail: '$109,994.00',
  modelPowerkW: '250 kW',
  modelMileage: '13,510',
  audiCode: 'ARJUY0CF',
  stockNumber: 'P5228',
  trimName: '55 TFSI quattro 335 HP tiptronic',
  kvpsSyncId: '93168',
  dealerName: 'Audi Downtown Toronto',
  dealerRegion: 'ON',
  vehicleType: 'used',
  warrantyType: 'used-car-warranty-type.plus',
  modelImageFromScs:
    'https://www.audi.ca/content/dam/nemo/ca/NoMo/collaboration/wormwod/default-images/default-normal.jpg',
  isAvailableNow: true,
  vin: 'WAU8DAF86MN006398',
  bodyType: 'Sedan',
  saleOrderType: null,
  vehicleInventoryType: 'CPO',
  vehicleOrderStatus: null,
  driveType: 'quattro',
  gearType: 'Automatic',
  distanceFromUser: 4,
  galleryImages: [],
};

export const TIER_3_CONFIG = {
  isTier3page: true,
  marketType: 'USA',
  listOfDealers: [
    { dealerName: 'Audi Rancho Mirage', dealerId: '22A49', isMainDealer: true },
    // { dealerName: 'Audi Dallas', dealerId: '25A70', isMainDealer: true },
    { dealerName: 'Audi Burlingame', dealerId: '26A31', isMainDealer: false },
  ],
  pageTitle: 'Vehicle inventory',
  pageDescription: 'page description',
  commonModelFamilies: [],
  isUrlParamsDynamic: false,
  isImageGalleryAble: true,
  filterTrayState: 'open',
  isVehicleTypeEnabled: true,
  vehicleTypeDisplayOptions: [],
  vehicleTypePreset: 'new',
  isMakeTypeEnabled: true,
  makeTypes: [],
  isModelFamilyEnabled: true,
  modelFamily: [],
  isModelYearEnabled: true,
  modelYear: [],
  isBodyTypeEnabled: true,
  bodyType: [],
  isTrimLineEnabled: true,
  trimLine: [],
  preused: [],
  isPriceEnabled: true,
  priceMin: undefined,
  priceMax: undefined,
  isMileageEnabled: true,
  isExteriorColorEnabled: true,
  exteriorColor: '',
  isInteriorColorEnabled: true,
  interiorColor: '',
  isFuelTypeEnabled: true,
  fuelType: '',
  mileageMax: undefined,
  isDriveTrainEnabled: true,
  driveTrain: '',
  isWheelSizeEnabled: true,
  isGearboxEnabled: true,
  isPowerEnabled: true,
  filterPositions: {
    vehicleTypePosition: 1,
    listOfDealersPosition: 2,
    bodyTypePosition: 4,
    makeTypesPosition: 3,
    modelFamilyPosition: 5,
    modelYearPosition: 7,
    trimLinePosition: 6,
    pricePosition: 11,
    mileagePosition: 10,
    exteriorColorPosition: 8,
    interiorColorPosition: 9,
    fuelTypePosition: 12,
    driveTrainPosition: 13,
    wheelSizePosition: 14,
    gearboxPosition: 15,
    powerPosition: 16,
  },
  filterPanelStates: {
    bodyTypePanelState: true,
    makeTypePanelState: true,
    modelFamilyPanelState: true,
    modelYearPanelState: true,
    trimLinePanelState: true,
    pricePanelState: false,
    mileagePanelState: true,
    exteriorColorPanelState: true,
    interiorColorPanelState: false,
    fuelTypePanelState: false,
    driveTrainPanelState: false,
    wheelSizePanelState: false,
    gearboxPanelState: false,
    powerPanelState: false,
    vehicleTypePanelState: true,
  },
  availableInMonths: '0',
  dataSource: 'jdp',
  'availability-now-label': '',
  'availability-all-label': '',
};
